class Acl {
    init(router, store, roles, fail, save) {
        this.router = router;
        this._router = router
        this._store = store;
        this.save = save;
        let me = this._store.getters["auth/getMe"];
        /*
        Use this for permissions
        let perms = this._store.getters["acl/getAccess"];
         */
        if (me && me.roles != null) roles = me.roles;

        this.permissions = this.clearPermissions(roles);
        this.savePermissions();
        this.fail = fail;
    }

    check(permission, strict = false) {
        if (this.permissions.indexOf('admin') >= 0) return true
        if (permission == undefined) return false;

        const permissions =
            permission.indexOf("|") !== -1 ? permission.split("|") : [permission];

        return this.findPermission(permissions, strict) !== undefined;
    }

    findPermission(pem, strict = false) {
        return pem.find(permission => {
            const needed =
                permission.indexOf("&") !== -1 ? permission.split("&") : permission;
            if (Array.isArray(needed)) {
                this.log(`Permission check type is (strict/no-strict) ${strict}: `, this.permissions, needed)
                if (strict) {
                    this.log(`Strict result: ${needed.every(need => this.permissions.indexOf(need) !== -1)}`)
                    return needed.every(need => this.permissions.indexOf(need) !== -1);
                } else {
                    this.log(`Non-strict result: ${needed.some(need => this.permissions.includes(need))}`)
                    return needed.some(need => this.permissions.includes(need));
                }
            }

            this.log(`Single permission check:  `, this.permissions, needed)
            return this.permissions.indexOf(needed) !== -1;
        });
    }

    clearPermissions(permissions) {
        if (permissions.indexOf("&") !== -1) permissions = permissions.split("&");

        return Array.isArray(permissions) ? permissions : [permissions];
    }

    savePermissions() {
        if (this.save != true) return;

        let perm = this.permissions;
        if (Array.isArray(this.permissions)) perm = this.permissions.join("&");
        this._store.commit("acl/changeAccess", perm);
    }

    set router(router) {
        router.beforeEach((to, from, next) => {
            if (
                to.meta.permissions === "guest" ||
                (to.meta.permissions instanceof Array && to.meta.permissions.indexOf("guest") >= 0)
            ) return next();

            let fail = to.meta.fail || this.fail || from.fullPath;

            if (!this.check(to.meta.permissions)) return next(fail);

            return next();
        });
    }

    canAccessRoute(routeName) {
        const routes = this._router?.options?.routes || []
        const routeFound = routes.find(route => route.name === routeName)
        this.log(`Checking route ${routeName}`)
        if(routeFound) return this.check(routeFound.meta.permissions)
        return true;
    }

    canAccessAnyRoute(routeNames) {
        return routeNames
            .map(routeName => this.canAccessRoute(routeName))
            .filter(routeCheck => routeCheck === true)
            .length > 0
    }

    canAccessRouteStartingWith(routeNameMatch) {
        const routes = this._router?.options?.routes || []
        const foundRoutes = routes.filter(route => route.name.startsWith(routeNameMatch))
        const accessibleRoutes = foundRoutes
            .map(route => this.check(route.meta.permissions))
            .filter(routeCheck => routeCheck === true)
        return foundRoutes.length === accessibleRoutes.length
    }

    log (data) {
        // console.log(data)
    }
}

let acl = new Acl();

Acl.install = (Vue, {router, store, init, fail, save}) => {
    const bus = new Vue();

    acl.init(router, store, init, fail, save);

    Vue.prototype.$can = permission => acl.check(permission);
    Vue.prototype.$canAccessRoute = routeName => acl.canAccessRoute(routeName);
    Vue.prototype.$canAccessRouteStartingWith = routeName => acl.canAccessRouteStartingWith(routeName);
    Vue.prototype.$canAccessAnyRoute = routeNames => acl.canAccessAnyRoute(routeNames);

    Vue.mixin({
        data() {
            return {
                access: acl.clearPermissions(init)
            };
        },
        watch: {
            access(value) {
                acl.permissions = acl.clearPermissions(value);
                bus.$emit("access-changed", acl.permissions);
                acl.savePermissions();
                this.$forceUpdate();
            }
        },
        mounted() {
            bus.$on("access-changed", permission => (this.access = permission));
            this.$root.$on("accessChanged", permission => this.access = permission);
        }
    });
};

export default Acl;
